import { render, staticRenderFns } from "./bigImg.vue?vue&type=template&id=760d1710&scoped=true"
import script from "./bigImg.vue?vue&type=script&lang=js"
export * from "./bigImg.vue?vue&type=script&lang=js"
import style0 from "./bigImg.vue?vue&type=style&index=0&id=760d1710&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760d1710",
  null
  
)

export default component.exports